export default __webpack_public_path__ + "static/media/tick.ae19cfe2.svg";